export default __webpack_public_path__ + "static/media/THSarabunNew-BoldItalic.e3138e09.ttf";